/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { useOutletContext, useParams } from 'react-router-dom';
import { AccountPaymentMethods, AccountReservations } from '@resy/ui-kitchen';
import FavoritesContainer from '../../containers/FavoritesContainer';
import MultipleListsContainer from '../../containers/MultipleListsContainer';
import MultipleListsDetailContainer from '../../containers/MultipleListsDetailContainer/MultipleListsDetailContainer';

const AccountReservationsOutlet = (props) => {
  const {
    flushRoute, presentCancelation, loadReservations,
  } = useOutletContext();
  const {
    $location, $rootScope, $route, Analytics, bookOnBehalfOf,
  } = props;
  return (
    <AccountReservations
      $location={$location}
      $rootScope={$rootScope}
      $route={$route}
      Analytics={Analytics}
      bookOnBehalfOf={bookOnBehalfOf}
      presentCancelation={presentCancelation}
      context="resy.com"
      flushRoute={flushRoute}
      loadReservations={loadReservations}
    />
  );
};
AccountReservationsOutlet.defaultProps = { bookOnBehalfOf: false };
AccountReservationsOutlet.propTypes = {
  $location: PropTypes.shape({}).isRequired,
  $rootScope: PropTypes.shape({}).isRequired,
  $route: PropTypes.shape({}).isRequired,
  Analytics: PropTypes.shape({}).isRequired,
  bookOnBehalfOf: PropTypes.bool,
};

const FavoritesContainerOutlet = (props) => {
  const {
    favoriteVenues, getQueuedData, isMobile, selectedDate, setQueuedData, showAuthModal,
  } = useOutletContext();
  const {
    $rootScope, Analytics,
  } = props;

  return (
    <FavoritesContainer
      $rootScope={$rootScope}
      Analytics={Analytics}
      favoriteVenues={favoriteVenues}
      getQueuedData={getQueuedData}
      isMobile={isMobile}
      selectedDate={selectedDate}
      setQueuedData={setQueuedData}
      showAuthModal={showAuthModal}
      store={$rootScope.reduxStore}
      context="resy.com"
    />
  );
};

FavoritesContainerOutlet.propTypes = {
  $rootScope: PropTypes.shape({
    reduxStore: PropTypes.shape({}),
  }).isRequired,
  Analytics: PropTypes.shape({}).isRequired,
};

const MultipleListsContainerOutlet = (props) => {
  const {
    favoriteVenues, isMobile, selectedDate, showAuthModal,
  } = useOutletContext();
  const {
    $location, $rootScope, $routeParams, Analytics,
  } = props;

  return (
    <MultipleListsContainer
      $location={$location}
      $rootScope={$rootScope}
      $routeParams={$routeParams}
      Analytics={Analytics}
      favoriteVenues={favoriteVenues}
      isMobile={isMobile}
      selectedDate={selectedDate}
      showAuthModal={showAuthModal}
      context="resy.com"
    />
  );
};

MultipleListsContainerOutlet.propTypes = {
  $location: PropTypes.shape({}).isRequired,
  $rootScope: PropTypes.shape({
    reduxStore: PropTypes.shape({}),
  }).isRequired,
  $routeParams: PropTypes.shape({}).isRequired,
  Analytics: PropTypes.shape({}).isRequired,
};

const MultipleListsDetailContainerOutlet = (props) => {
  const {
    favoriteVenues, getQueuedData, isMobile, selectedDate, setQueuedData, showAuthModal,
  } = useOutletContext();
  const {
    $rootScope, $routeParams, Analytics,
  } = props;
  // Consolidated AngularJS route only exposes `section`/`sub`/`subsub`,
  // so merge React Router's `listId`/`urlSlug` into `$routeParams`.
  const mergedRouteParams = { ...$routeParams, ...useParams() };

  return (
    <MultipleListsDetailContainer
      $rootScope={$rootScope}
      $routeParams={mergedRouteParams}
      Analytics={Analytics}
      favoriteVenues={favoriteVenues}
      getQueuedData={getQueuedData}
      isMobile={isMobile}
      selectedDate={selectedDate}
      setQueuedData={setQueuedData}
      showAuthModal={showAuthModal}
      context="resy.com"
    />
  );
};

MultipleListsDetailContainerOutlet.propTypes = {
  $rootScope: PropTypes.shape({
    reduxStore: PropTypes.shape({}),
  }).isRequired,
  $routeParams: PropTypes.shape({}).isRequired,
  Analytics: PropTypes.shape({}).isRequired,
};

const AccountPaymentMethodsOutlet = (props) => {
  const { flushRoute, isGdaEligible, modalType } = useOutletContext();
  const {
    Analytics, AutomationMode,
  } = props;
  return (
    <AccountPaymentMethods
      Analytics={Analytics}
      AutomationMode={AutomationMode}
      isGda={isGdaEligible}
      modalType={modalType}
      context="resy.com"
      flushRoute={flushRoute}
    />
  );
};

AccountPaymentMethodsOutlet.propTypes = {
  Analytics: PropTypes.shape({}).isRequired,
  AutomationMode: PropTypes.bool.isRequired,
};

export {
  AccountPaymentMethodsOutlet,
  AccountReservationsOutlet,
  FavoritesContainerOutlet,
  MultipleListsContainerOutlet,
  MultipleListsDetailContainerOutlet,
};
